<!-- Assign -->
<div *ngIf="taskGroup.mode === 'assign'">
	<div class="modal-header">
	    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.taskAssignHeader}}</h3>
	</div>
	<div class="modal-body dx-form">
	    <form #kvForm="ngForm" name="kvForm" class="form-signin" style="max-width:400px">
	        <div class="row">
	            <div class="col-md-12" >
	                <label for="owner">{{LOCALIZATION.assignTo}}</label>
					<select id="owner" name="owner" class="form-control" [(ngModel)]="taskGroup.owner" required autofocus>
					  <option *ngFor="let owner of taskGroup.potentialOwners" [ngValue]="owner.username">{{owner.lastName}}, {{owner.firstName}} ({{owner.username}})</option>
					</select>
	            </div>
	        </div>
	        <div class="row">
	            <div class="col-md-12" >
	                <label for="comment">{{LOCALIZATION.comments}}</label>
	                <textarea [(ngModel)]='taskGroup.comment' id="comment" name="comment" class="form-control" rows="4" cols="70"></textarea>
	            </div>
	        </div>
	    </form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	    <button class="btn btn-primary" type="button" (click)="assignTasks()" [disabled]="!kvForm.valid || inprogress">
	    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
	    	{{LOCALIZATION.assign}}
	    </button>
	</div>	
</div>

<!-- Reject -->
<div *ngIf="taskGroup.mode === 'reject'">
	<div class="modal-header">
	    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.taskRejectHeader}}</h3>
	</div>
	<div class="modal-body dx-form">
	    <form class="form-signin" style="max-width:400px">
	        <div class="row">
	            <div class="col-md-12" >
	                <label for="comment">{{LOCALIZATION.comments}}</label>
	                <textarea [(ngModel)]='taskGroup.comment' id="comment" name="comment" class="form-control" rows="4" cols="70"></textarea>
	            </div>
	        </div>
	    </form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	    <button class="btn btn-primary" type="button" (click)="rejectTasks()" [disabled]="inprogress">
	    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
	    	{{LOCALIZATION.reject}}
	    </button>
	</div>	
</div>

<div *ngIf="!taskGroup.mode">
	<div>The operation is not supported</div>
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
